import * as React from 'react';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { CognitoIdentityProviderClient, AdminResetUserPasswordCommand } from '@aws-sdk/client-cognito-identity-provider'; 
import { get } from 'lodash';

import { getCurrentCredentials } from '../Auth';
import config from '../../../config';
import { ErrorMessage, SuccessMessage } from '../alerts';

interface State {
  userId?: string;
  userEmail?: string;
  isOpen?: boolean | undefined;
  successMessage?: string | undefined;
  errorMessage?: string | undefined;
}
class AdminResetPassword extends React.Component<{}, State> {
  cognitoIdentityServiceProviderClient;

  constructor(props: {}) {
    super(props);
    this.state = {
      isOpen: false,
    };
  }
  async componentDidMount(): Promise<void> {
    const credentials = await getCurrentCredentials();

    this.cognitoIdentityServiceProviderClient = new CognitoIdentityProviderClient({
       region: config.cognito.REGION,
       credentials: {
         accessKeyId: get(credentials, 'accessKeyId'),
         sessionToken: get(credentials, 'sessionToken'),
         secretAccessKey: get(credentials, 'secretAccessKey'),
       }
     });

    this.setState({
      isOpen: this.state.isOpen
    });
  }
  /**
   * Resetting the password and error checking
   */
  resetPassword = async (): Promise <void> => {
    if (this.state.userId) {
      try {
        const command = new AdminResetUserPasswordCommand({
          Username: this.state.userId,
            UserPoolId: config.cognito.USER_POOL_ID
        });
        await this.cognitoIdentityServiceProviderClient.send(command);
        this.setState({
          successMessage: 'User has been sent an email to reset their password.'
        });
      } catch (e: any) { // eslint-disable-line @typescript-eslint/no-explicit-any
        this.setState({
          errorMessage: `Something went wrong, please try again later. (${e.message})`
        });
      }
    } else {
      this.setState({
        errorMessage: 'No userid supplied.'
      });
    }
  };
  /**
   * Toggles the open state for the resetPassword Modal
   */
  resetPasswordModalToggle = () => {
    this.setState(prevState => ({
      isOpen: !prevState.isOpen,
      successMessage: undefined,
      errorMessage: undefined
    }));
  };
  /**
   * Get the user details
   */
  loadDetails(userId: string, userEmail: string) {
    if (userId) {
      this.setState({ userId: userId, userEmail: userEmail, isOpen: true });
    } else {
      this.setState({ errorMessage: 'No user id', isOpen: true });
    }
  }
 /**
  * Hide the button if there's a message
  */
  confirmButton = () => {
    if (this.state.errorMessage || this.state.successMessage) {
      return <></>;
    } else {
        return <Button color="danger" onClick={this.resetPassword}>Yes, I&apos;m sure</Button>;
      }
    };

  render() {
    const hasError = (this.state.successMessage || this.state.errorMessage);

    return (
      <Modal isOpen={this.state.isOpen} toggle={this.resetPasswordModalToggle}>
        <ModalHeader>Reset Password</ModalHeader>
        <ModalBody>
          {
            hasError ?
              <>
                <SuccessMessage message={this.state.successMessage}/>
                <ErrorMessage message={this.state.errorMessage}/>
              </>
            :
              <>Reset Password for {this.state.userEmail ? this.state.userEmail : this.state.userId}?</>
          }
        </ModalBody>
        <ModalFooter>
          {this.confirmButton()}
          <Button color="secondary" onClick={this.resetPasswordModalToggle}>
            {this.state.successMessage ? 'Ok' : 'Cancel'}
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}
export default AdminResetPassword;
